import { render } from "./PensamientosTab.vue?vue&type=template&id=59a6b643&scoped=true"
import script from "./PensamientosTab.vue?vue&type=script&lang=js"
export * from "./PensamientosTab.vue?vue&type=script&lang=js"

import "./PensamientosTab.vue?vue&type=style&index=0&id=59a6b643&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a6b643"]])

export default __exports__